<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row dflex">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="search1" (click)='open_filter()'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,1,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" class='table-scroll mat_table_en_without_scroll_bg pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'
                (click)="reset_sort('repairman_reception_id2','desc')">
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
                page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:45px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'repairman_reception_date ' + asc_desc }"
                (click)="sort('repairman_reception_date',asc_desc)" style="max-width: 100px;">
                <span> تاریخ </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)"
                style="max-width: 100px;">
                {{ x.repairman_reception_date }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 100px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'user_title ' + asc_desc }"
                (click)="sort('user_title',asc_desc)" style="min-width: 180px;">
                <span> طرف حساب</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)"
                style="min-width: 180px;">
                <div class="right">{{ x.customer_title }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width: 180px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="reception_id">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'repairman_reception_id2 ' + asc_desc }"
                (click)="sort('repairman_reception_id2',asc_desc)" style="max-width: 100px;">
                <span>شماره پذیرش</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)"
                style="max-width: 100px;">
                {{ x.repairman_reception_id2 }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 100px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="model">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'model_title ' + asc_desc }"
                (click)="sort('model_title',asc_desc)" style="min-width: 200px;">
                <span>برند و مدل</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)"
                style="min-width: 200px;">
                {{ x.model_title }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width: 200px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="invoice">
            <mat-header-cell *matHeaderCellDef style="max-width: 100px;"
                [ngClass]="{active1:order == 'repairman_reception_invoice_count ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_count',asc_desc)">
                <span>درج فاکتور</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)"
                [ngClass]="{'green' : x.repairman_reception_invoice_count > 0}" style="max-width: 100px;">
                <span>درج فاکتور</span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 100px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="sum">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'repairman_reception_invoice_sum ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_sum',asc_desc)">
                <span>جمع فاکتور</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)">
                {{ x.repairman_reception_invoice_sum || 0 | number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ sum || 0 | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="sum_material">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'repairman_reception_invoice_sum_material ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_sum_material',asc_desc)">
                <span>کالاها</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)">
                {{ x.repairman_reception_invoice_sum_material || 0 | number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ sum_material || 0 | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="sum_service">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'repairman_reception_invoice_sum_service ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_sum_service',asc_desc)">
                <span>خدمات</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)">
                {{ x.repairman_reception_invoice_sum_service || 0 | number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ sum_service || 0 | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="sum_costs">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'repairman_reception_invoice_sum_costs ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_sum_costs',asc_desc)">
                <span>افزاینده فاکتور</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)">
                {{ x.repairman_reception_invoice_sum_costs || 0 | number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ sum_costs || 0 | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="commission">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'repairman_reception_invoice_commission ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_commission',asc_desc)">
                <span>جمع کمیسیون</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)">
                {{ x.repairman_reception_invoice_commission || 0 | number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ sum_commission || 0 | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="profit">
            <mat-header-cell *matHeaderCellDef style="max-width: 100px;"
                [ngClass]="{active1:order == 'repairman_reception_invoice_profit ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_profit',asc_desc)">
                <span>سود فاکتور</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)"
                style="max-width: 100px;">
                {{ x.repairman_reception_invoice_profit || 0 | number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 100px;">{{ sum_profit || 0 | number
                }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="discount">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'repairman_reception_invoice_discount ' + asc_desc }"
                (click)="sort('repairman_reception_invoice_discount',asc_desc)">
                <span>تخفیف</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_exit(i,x.repairman_reception_id)">
                {{ x.repairman_reception_invoice_discount || 0 | number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef>{{ sum_discount || 0 | number }}</mat-footer-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true"></mat-footer-row>
    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets//images/preview.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>